import { Form } from './form';
import { Config } from '../config';
import { Order } from '../config/order';
import { FormTypes } from './form-types';
import { FacebookPixelView } from '../view/facebook-pixel-view';

export class FacebookPixelForm extends Form {

    type = FormTypes.FacebookPixel;
    view: FacebookPixelView = new FacebookPixelView();

    constructor() {
        super();
    }

    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
    }

    async render() {
        this.view.render(this.config.analytics.facebookPixelId);
        return Promise.resolve();
    }

    submit(order: Order) {
        return Promise.resolve(order);
    }

    postSubmit(submissionContext: any): Promise<any> {
        this.sendPurchaseEvent();
        return Promise.resolve();
    }

    sendPurchaseEvent = () => {
        const fbq = this.view.getFbqInstance();
        fbq(
            'track',
            'Purchase',
            {
                value: this.config.widget.totalAmount,
                currency: this.config.settings.currency,
                content_name: this.getProductName()
            }
        );
    }

    getProductName = () => {
        const selectedProducts = this.config.widget.getAllSelectedProducts();
        return selectedProducts.map((selectedProduct: any) => selectedProduct.name).join(', ');
    }

}
